<template>
  <v-container>
    <template v-if="enterprise">
      <div class="header-portofolio">
        <v-img :src="enterprise.logo" contain width="100"></v-img>

        <a :href="enterprise.url" target="_blank">
          <v-icon class="icon-enlace"></v-icon>
          <span>{{ enterprise.url }}</span>
        </a>

        <span class="mx-4 d-none d-sm-block">|</span>

        <div>
          <a :href="enterprise.facebook" target="_blank">
            <v-icon class="icon-facebook"></v-icon>
          </a>
          <a :href="enterprise.linkedin" target="_blank">
            <v-icon class="icon-linkedin"></v-icon>
          </a>
          <a :href="enterprise.instragram" target="_blank">
            <v-icon class="icon-instagram"></v-icon>
          </a>
        </div>
      </div>

      <v-img :src="enterprise.banner"></v-img>

      <OurInvestmentsInfo :investmentInfo="enterpriseInfo" />

      <PersonalCard v-if="CEOInfo.full_name" :personalInfo="CEOInfo" />

      <ApplyCard />

      <div class="text-center mb-5">
        <v-btn text @click="goToNextPage()">
          <span v-html="$t('global.see_next_startup')"></span>
          <v-icon class="icon-flecha-derecha"></v-icon>
        </v-btn>
      </div>

      <v-divider class="my-4 my-sm-8"></v-divider>
    </template>

    <div v-else class="text-center my-12">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
import ApplyCard from "@/components/ApplyCard.vue";
import OurInvestmentsInfo from "@/components/OurInvestmentsInfo.vue";
import PersonalCard from "@/components/PersonalCard.vue";

import { REQUEST_PORTOFOLIO_CONTENT } from "@/store/actions/portofolio";

export default {
  name: "EnterpriseDetail",

  components: {
    ApplyCard,
    OurInvestmentsInfo,
    PersonalCard,
  },

  computed: {
    enterprisesList() {
      const content = this.$store.getters.getPortofolioContent;
      return content?.data?.enterprises || [];
    },

    locale() {
      return this.$store.getters.getLanguage;
    },

    enterprise() {
      if (!this.enterprisesList.length) return null;
      return (
        this.enterprisesList.find((e) => e.href === this.$route.params.href) ||
        null
      );
    },

    enterpriseInfo() {
      if (!this.enterprise) return {};
      return {
        legend: this.enterprise.title,
        description: this.enterprise.short_description,
        founders: this.enterprise.founders || [],
      };
    },

    CEOInfo() {
      const founders = (this.enterprise && this.enterprise.founders) || [];
      if (!founders.length) return {};
      return founders.find((f) => f.job_position === "CEO") || founders[0];
    },

    nextEnterprise() {
      if (!this.enterprise || !this.enterprisesList.length) return null;
      const index = this.enterprisesList.findIndex(
        (e) => e.href === this.enterprise.href
      );
      if (index === -1) return null;
      return this.enterprisesList[(index + 1) % this.enterprisesList.length];
    },
  },

  watch: {
    locale() {
      this.$store.dispatch(REQUEST_PORTOFOLIO_CONTENT);
    },
  },

  created() {
    if (!this.enterprisesList.length) {
      this.$store.dispatch(REQUEST_PORTOFOLIO_CONTENT);
    }
  },

  mounted() {
    if (this.$gtm && typeof this.$gtm.trackView === "function") {
      this.$gtm.trackView("Enterprise", "/portfolio/:href");
    }
  },

  methods: {
    goToNextPage() {
      if (!this.nextEnterprise) return;
      this.$router.push({
        name: "Enterprise",
        params: { href: this.nextEnterprise.href },
      });
    },
  },
};
</script>
